import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Password.css";

const Password = ({ oldpassword, setOldpassword, newpassword, setNewpassword, confirmpassword, setConfirmpassword }) => {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState(0);
    const [validationErrors, setValidationErrors] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
        match: false
    });

    useEffect(() => {
        // Password strength calculation
        let strength = 0;
        const errors = {
            length: false,
            uppercase: false,
            lowercase: false,
            number: false,
            special: false,
            match: false
        };

        if (newpassword) {
            // Length check
            if (newpassword.length >= 8) {
                strength += 1;
                errors.length = true;
            }

            // Uppercase check
            if (/[A-Z]/.test(newpassword)) {
                strength += 1;
                errors.uppercase = true;
            }

            // Lowercase check
            if (/[a-z]/.test(newpassword)) {
                strength += 1;
                errors.lowercase = true;
            }

            // Number check
            if (/[0-9]/.test(newpassword)) {
                strength += 1;
                errors.number = true;
            }

            // Special character check
            if (/[!@#$%^&*(),.?":{}|<>]/.test(newpassword)) {
                strength += 1;
                errors.special = true;
            }

            // Password match check
            if (confirmpassword && newpassword === confirmpassword) {
                errors.match = true;
            }
        }

        setPasswordStrength(strength);
        setValidationErrors(errors);
    }, [newpassword, confirmpassword]);

    const getStrengthColor = () => {
        if (passwordStrength <= 2) return "#ff4d4d";
        if (passwordStrength <= 3) return "#ffa64d";
        if (passwordStrength <= 4) return "#ffff4d";
        return "#4dff4d";
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-passwordholder tab-pane active fade show" id="dc-password">
                <div className="dc-changepassword">
                    <div className="dc-tabscontenttitle">
                        <h3>Change Your Password</h3>
                    </div>
                    <div className="dc-formtheme dc-userform dc-sidepadding">
                        <fieldset>
                            <div className="form-group form-group-half">
                                <div className="password-input-container">
                                    <input 
                                        type={showOldPassword ? "text" : "password"}
                                        name="password" 
                                        className="form-control" 
                                        placeholder="Last Remember Password"
                                        value={oldpassword}
                                        onChange={(e) => setOldpassword(e.target.value)}
                                    />
                                    <span 
                                        className="password-toggle"
                                        onClick={() => setShowOldPassword(!showOldPassword)}
                                    >
                                        {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                            </div>
                            <div className="form-group form-group-half">
                                <div className="password-input-container">
                                    <input 
                                        type={showNewPassword ? "text" : "password"}
                                        name="retype" 
                                        className="form-control" 
                                        placeholder="New Password"
                                        value={newpassword}
                                        onChange={(e) => setNewpassword(e.target.value)}
                                    />
                                    <span 
                                        className="password-toggle"
                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                    >
                                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                                {newpassword && (
                                    <div className="password-strength-container">
                                        <div className="password-strength-bar">
                                            <div 
                                                className="password-strength-indicator"
                                                style={{
                                                    width: `${(passwordStrength / 5) * 100}%`,
                                                    backgroundColor: getStrengthColor()
                                                }}
                                            />
                                        </div>
                                        <div className="password-requirements">
                                            <p className={validationErrors.length ? "valid" : "invalid"}>
                                                • At least 8 characters long
                                            </p>
                                            <p className={validationErrors.uppercase ? "valid" : "invalid"}>
                                                • At least one uppercase letter
                                            </p>
                                            <p className={validationErrors.lowercase ? "valid" : "invalid"}>
                                                • At least one lowercase letter
                                            </p>
                                            <p className={validationErrors.number ? "valid" : "invalid"}>
                                                • At least one number
                                            </p>
                                            <p className={validationErrors.special ? "valid" : "invalid"}>
                                                • At least one special character
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="form-group form-group-half">
                                <div className="password-input-container">
                                    <input 
                                        type={showConfirmPassword ? "text" : "password"}
                                        name="retype" 
                                        className="form-control" 
                                        placeholder="Confirm New Password"
                                        value={confirmpassword}
                                        onChange={(e) => setConfirmpassword(e.target.value)}
                                    />
                                    <span 
                                        className="password-toggle"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                                {confirmpassword && (
                                    <p className={validationErrors.match ? "valid" : "invalid"}>
                                        {validationErrors.match ? "Passwords match" : "Passwords do not match"}
                                    </p>
                                )}
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Password;
